import { CommissionPayPlanType } from './commission-pay-plan-type';

export class SupplierCompensationReport {
	upfrontPercentage: number;
	hasAnniversaryUpfront: boolean;
	paymentRule: string;
	description: string;
	rating: string;
	commodity: string;
	serviceTypeId: string;
	marginSplitRule: string;
	supplier: string;
	supplierId: string;
	isActive: boolean;
	marginCapRule: string;
	paymentAmount: string;
	residentialRenewalWindow: number;
	acceptsResidentialRenewals: boolean;
	renewalPaymentAmount: string;
	paymentTimeLag: string;
	renewalPaymentTimeLag: string;
	residualPaymentRule: string;
	upfrontPaymentRule: string;
	upfront50PaymentRule: string;
	quickPayUpfront50PaymentRule: string;
	quickPayUpfrontPaymentRule: string;
	quickPayDescription: string;
	commissionPayPlanTypes: CommissionPayPlanType[];

	constructor(supplierCompensationReport?: SupplierCompensationReport) {
		Object.assign(this, supplierCompensationReport);
	}

	public receivablePlan(isResidential: boolean) {
		if (isResidential) {
			return this.paymentRule;
		}

		if (this.upfrontPercentage === 0) {
			return 'Residual';
		}

		return `${this.upfrontPercentage}% Upfront`;
	}
}
